import { NgModule } from '@angular/core';
import { TranslatePipe } from '../pipe/translate.pipe';
import { CommonModule } from '@angular/common';
import { TranslateDirective } from '../directives/translate.directive';
import { TranslateService } from '@client/app/services/translate/translate.service';

@NgModule({
    imports: [CommonModule],
    exports: [TranslatePipe, TranslateDirective],
    declarations: [TranslatePipe, TranslateDirective],
    providers: [
        TranslateService,
    ],
})
export class TranslateModule {}
